export enum ListType {
  Shipment = 'Shipment',
  AddPros = 'AddPros',
  Lookup = 'Lookup',
  RecommendationRules = 'RecommendationRules',
  CustomerGuidelines = 'CustomerGuidelines',
  BroadcastMessage = 'BroadcastMessage',
  PickUpRequest = 'PickupRequest'
}
